<p>Ensure that <b>Retail</b> tab is completed before proceeding to <b>Config set</b>, and <b>Config set</b>  is completed before moving on to <b>Rollout group</b>, and <b>Rollout group </b>  is completed before moving on to <b>Store</b>.</p>
<div class="form-group row" *ngIf="!!createResult && createResult.success == false">
  <div *ngIf="raiseDanger" style="width:100%">
    <ngb-alert [dismissible]="false" type="danger">
      <strong>Error!</strong> {{createResult.message}}
    </ngb-alert>
  </div>
</div>
<div class="form-group row" *ngIf="!!createResult && createResult.success == true">
  <div style="width:100%">
    <ngb-alert [dismissible]="false" type="info">
      {{createResult.message}}
    </ngb-alert>
  </div>
</div>
<ul ngbNav #nav="ngbNav" class="nav nav-tabs" (activeIdChange)="initTable($event)">
  <li [ngbNavItem]="1">
    <a ngbNavLink>Retail</a>
    <ng-template ngbNavContent>
      <div class="row">
        <div class="col-12">
          <form [formGroup]="retailerForm" name="form" autocomplete="off">
            <div class="row form-horizontal">
              <div class="col-md-6 form-horizontal px-3">

                <div class="form-group row">
                  <label for="retailerId" class="col-3 col-form-label">Retailer Id:</label>
                  <div class="col-9">
                    <input formControlName="retailerId" class="form-control" id="retailerId" placeholder="" maxlength="12">
                    <ul *ngIf="submittedRetailer || retailerForm.controls.retailerId.touched" class="parsley-errors-list filled">
                      <li *ngIf="retailerForm.controls.retailerId.hasError('required')" class="parsley-required">Retailer Id is required.</li>
                    </ul>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="name" class="col-3 col-form-label">Retailer Name:</label>
                  <div class="col-9">
                    <input formControlName="name" class="form-control" id="name" placeholder="">
                    <ul *ngIf="submittedRetailer || retailerForm.controls.name.touched" class="parsley-errors-list filled">
                      <li *ngIf="retailerForm.controls.name.hasError('required')" class="parsley-required">Retailer name is required.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 form-horizontal px-3">
            </div>
            <div class="form-group row float-right">
              <button *ngIf="newRetailer" type="submit" class="btn btn-info waves-effect waves-light float-right m-2" (click)="importRetailer()">
                <i class="mdi mdi-content-save"></i>Sync Retailer
              </button>
            </div>
          </form>
        </div>
      </div>
    </ng-template>
  </li>

  <li [ngbNavItem]="2">
    <a ngbNavLink>Config set</a>
    <ng-template ngbNavContent>

      <div class="row">
        <div class="col-12">
          <form [formGroup]="configSetForm" name="form" autocomplete="off">


            <div class="row form-horizontal">

              <div class="col-md-6 form-horizontal px-3">
                <div class="form-group row">
                  <label for="retailerId" class="col-3 col-form-label">Retailer Id:</label>
                  <div class="col-9">
                    <input formControlName="retailerId" class="form-control" id="retailerId" placeholder="Retailer id" disabled="disabled" />
                    <ul *ngIf="submittedConfigSet || configSetForm.controls.retailerId.touched" class="parsley-errors-list filled">
                      <li *ngIf="configSetForm.controls.retailerId.hasError('required')" class="parsley-required">Retailer name is required.</li>
                    </ul>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="configidsuffix" class="col-3 col-form-label">Config Id Suffix:</label>
                  <div class="col-9">
                    <input formControlName="configIdSuffix" class="form-control" id="configIdSuffix" placeholder="Config id suffix" maxlength="8">
                    <ul *ngIf="submittedConfigSet || configSetForm.controls.configIdSuffix.touched" class="parsley-errors-list filled">
                      <li *ngIf="configSetForm.controls.configIdSuffix.hasError('required')" class="parsley-required">Config Id Suffix is required.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group row float-right">
              <button type="submit" class="btn btn-info waves-effect waves-light float-right m-2" (click)="SyncConfigSet()">
                <i class="mdi mdi-content-save"></i>Sync Config set
              </button>
            </div>
          </form>
        </div>
      </div>
    </ng-template>
  </li>

  <li [ngbNavItem]="3">
    <a ngbNavLink>Store</a>
    <ng-template ngbNavContent>
      <div class="row">
        <div class="col-12">
          <form [formGroup]="storeForm" name="form" autocomplete="off">

            <div class="row form-horizontal">

              <div class="col-md-6 form-horizontal px-3">

                <div class="form-group row">
                  <label for="name" class="col-3 col-form-label">Retailer Id:</label>
                  <div class="col-9">
                    <input formControlName="retailerId" class="form-control" id="retailerId" placeholder="Retailer Id" disabled="disabled">
                  </div>
                </div>
                <div class="form-group row">
                  <label for="name" class="col-3 col-form-label">Store Id:</label>
                  <div class="col-9">
                    <input formControlName="storeId" class="form-control" id="storeId" placeholder="Store Id" maxlength="25">
                    <ul *ngIf="submittedStore || storeForm.controls.storeId.touched" class="parsley-errors-list filled">
                      <li *ngIf="storeForm.controls.storeId.hasError('required')" class="parsley-required">Store Id is required.</li>
                    </ul>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12  float-right">
                    <button type="submit" class="btn btn-info waves-effect waves-light float-right" (click)="SyncStore()">
                      <i class="mdi mdi-content-save"></i>Sync Store
                    </button>
                  </div>
                </div>
                <div class="form-group row">

                  <table class="table table-striped" *ngIf="getStores.length > 1">

                    <thead>
                      <tr colspan="3">
                        List of availble stores
                      </tr>
                      <tr>
                        <th>Retailer Id</th>
                        <th>Store Id</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr scope="col" *ngFor="let s of getStores">
                        <td>{{s.retailerId}}</td>
                        <td>{{s.storeId}}</td>
                        <td>
                          <button type="button"
                                  class="btn btn-danger waves-effect waves-light fa-pull-right mx-1"
                                  (click)="deleteStore(s)">
                            Unlink <i class="mdi mdi-delete"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-md-6 form-horizontal px-3">
              </div>
              <div class="form-group row float-right">

              </div>
            </div>
          </form>
        </div>
      </div>
    </ng-template>
  </li>

  <li [ngbNavItem]="4">
    <a ngbNavLink>Lane profiles</a>
    <ng-template ngbNavContent>
      <div class="row">
        <div class="col-12">
          <form [formGroup]="LaneProfilesForm" name="form" autocomplete="off">
            <div class="row form-horizontal">
              <div class="col-md-6 form-horizontal px-3">

                <div class="form-group row">
                  <label for="name" class="col-3 col-form-label">Retailer Id:</label>
                  <div class="col-9">
                    <input formControlName="retailerId" class="form-control" id="retailerId" placeholder="Retailer Id" disabled="disabled">
                  </div>
                </div>
                <div class="form-group row">
                  <label for="retailerId" class="col-3 col-form-label">Lane profile:</label>
                  <div class="col-9">
                    <input formControlName="laneProfile" class="form-control" id="laneProfile" placeholder="" maxlength="20">
                    <ul *ngIf="submittedLaneProfilesForm || LaneProfilesForm.controls.laneProfile.touched" class="parsley-errors-list filled">
                      <li *ngIf="LaneProfilesForm.controls.laneProfile.hasError('required')" class="parsley-required">lane profile is required.</li>
                    </ul>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12  float-right">
                    <button type="submit" class="btn btn-info waves-effect waves-light float-right" (click)="SyncLaneProfile()">
                      <i class="mdi mdi-content-save"></i>Sync Lane profile
                    </button>
                  </div>
                </div>
                <div class="form-group row">

                  <table class="table table-striped" *ngIf="getStores.length > 1">

                    <thead>
                      <tr colspan="3">
                        List of availble lane profiles
                      </tr>
                      <tr>
                        <th>RetailerId</th>
                        <th>Lane profile</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr scope="col" *ngFor="let s of getLaneProfiles">
                        <td>{{s.retailerId}}</td>
                        <td>{{s.laneProfile}}</td>
                        <td>
                          <button type="button"
                                  class="btn btn-danger waves-effect waves-light fa-pull-right mx-1"
                                  (click)="deleteLaneProfile(s)">
                            Unlink <i class="mdi mdi-delete"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>

          </form>
        </div>
      </div>
    </ng-template>
  </li>

  <li [ngbNavItem]="5">
    <a ngbNavLink>Additional configs</a>
    <ng-template ngbNavContent>
      <div class="row">
        <div class="col-12">
          <form [formGroup]="AdditionalConfigForm" name="form" autocomplete="off">
            <div class="row form-horizontal">
              <div class="col-md-6 form-horizontal px-3">

                <div class="form-group row">
                  <label for="commandPort" class="col-3 col-form-label">Command port:</label>
                  <div class="col-9">
                    <input formControlName="commandPort" class="form-control" id="commandPort" placeholder="" maxlength="10">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="name" class="col-3 col-form-label">Connection type:</label>
                  <div class="col-9">
                    <input formControlName="connType" class="form-control" id="connType" placeholder="">
                    <ul *ngIf="submittedAdditionalConfigForm || AdditionalConfigForm.controls.connType.touched" class="parsley-errors-list filled">
                      <li *ngIf="AdditionalConfigForm.controls.connType.hasError('required')" class="parsley-required">Connection type is required.</li>
                    </ul>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="name" class="col-3 col-form-label">Rank:</label>
                  <div class="col-9">
                    <input formControlName="rank" class="form-control" id="rank" placeholder="">
                    <ul *ngIf="submittedAdditionalConfigForm || AdditionalConfigForm.controls.rank.touched" class="parsley-errors-list filled">
                      <li *ngIf="AdditionalConfigForm.controls.rank.hasError('required')" class="parsley-required">Rank type is required.</li>
                    </ul>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="name" class="col-3 col-form-label">Sap address:</label>
                  <div class="col-9">
                    <input formControlName="sapAddress" class="form-control" id="sapAddress" placeholder="" maxlength="128">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="customData" class="col-3 col-form-label">Custom data:</label>
                  <div class="col-9">
                    <textarea formControlName="customData" class="form-control" id="customData" placeholder=""></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 form-horizontal px-3">


            </div>
            <div class="form-group row float-right">
              <button type="submit" class="btn btn-info waves-effect waves-light float-right m-2" (click)="saveUpdateAdditionalConfig()">
                <i class="mdi mdi-content-save"></i>Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav"></div>
